import { Tooltip } from "@material-ui/core";
import { ReactComponent as CopyIconGray } from 'assets/icons/CopyIconGray.svg';
import { ReactComponent as BlankLink } from 'assets/icons/Group 240018.svg';
import { ReactComponent as InfoIcon } from 'assets/icons/Layer_2.svg';
import { ReactComponent as ClassNoData } from 'assets/icons/class_noResult.svg';
import { AlertMessage } from "components/AlertMessage";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect } from 'react';
import { CopyToClipboard } from "react-copy-to-clipboard";
import './eventInformation.scss';
import { fontConfig } from "theme/fontConfig";

const DATES_VISIBLE = 1;

const InternalDrawer = ({ formik }) => {
  const [copyLinkSuccess, setCopyLinkSuccess] = React.useState(false);

    const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
    const orgKey = organization?.orgkey;
    const mainUrl = window.location.origin;
    const checkDomain =
    mainUrl === 'https://admin.eztmpl.dev' ||
    mainUrl === 'http://localhost:3000'
      ? `https://shalom.eztmpl.dev/events/${formik?.values?.id}`
      : mainUrl === 'https://admin.eztmpl.com'
      ? `https://demo.eztmpl.com/events/${formik?.values?.id}`
      : mainUrl === 'https://admin.easyshul.com'
      ? `https://${orgKey}.easyshul.com/events/${formik?.values?.id}`
      : null;

      useEffect(() => {
        const timer = setTimeout(() => {
          setCopyLinkSuccess(false);
        }, 2000);
        return () => clearTimeout(timer);
      }, [copyLinkSuccess]);


  const calculateProductPrice = (price) => {
    if((price?.type?.toLowerCase() === 'optional' || price?.type?.toLowerCase() === 'tickets' || price?.type?.toLowerCase() === 'addons') && price?.variant) {
      const amounts = Object.values(price?.variantInfo).map(product => product.amount || 0);
      const minAmount = Math.min(...amounts);
      const maxAmount = Math.max(...amounts);
      return `${numberFormat({number:+minAmount, decimal: 2, style: "currency"})} - ${numberFormat({number:+maxAmount, decimal: 2, style: "currency"})}`;
    } else if(price?.type?.toLowerCase() === 'open amount') {
      return `${numberFormat({number:+price?.minimumOpenAmount, decimal: 2, style: "currency"})}`;
    } else if(price?.type?.toLowerCase() === 'no payment needed') {
      return '$0.00';
    } else {
      return `${numberFormat({number:+price?.amount, decimal: 2, style: "currency"})}`;
    }
  }


  return (
    <>
      {formik.currentStepIndex !== 0 ? (
        <div className="internal_drawer">
        {copyLinkSuccess && (
          <div className="copy-alert">
            <AlertMessage type="success" content="URL Copied Successfully" />
          </div>
        )}
          <h2 className="drawer_title">
            <div>Event Details</div>
            {formik?.values?.id && (
            <a
              className="d-flex align-items-center preview__class"
              href={checkDomain}
              target="_blank"
              rel="noopener noreferrer"
            >
              <BlankLink className="mr-2" /> Preview Event
            </a>
          )}
          </h2>
          <div className="drawer_classInfo">
            <div className="class_info_title">
              <h3>Event Name</h3>
              <h3>Registration Starts-ends</h3>
            </div>
            <div className="class_info_value justify-content-end">
              <p>{formik.values?.eventName}</p>
              {formik.values?.eventStartDate && (
                <p>
                  {formatDate({date:formik.values?.eventStartDate, formatType:"defaultWithTimeEST"})} 
                  -{' '}
                  {formik.values?.alwaysAvailable ? "Always Available" 
                  : formatDate({date:formik.values?.eventEndDate, formatType:"defaultWithTimeEST"})}
                </p>
              )}
            </div>
          </div>
          <div className="class_details_section mt-4">
            <div>
              <h3
                title={formik.values?.eventDetails?.eventType}
                style={{
                  width: '100px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'center',
                }}
                className="internal-drawer__event-type"
              >
                {formik.values?.eventDetails?.eventType}
              </h3>
              <h4>Event type</h4>
            </div>
            <hr className="internal-drawer__event_details-separator" />
            <div className="internal-drawer__event_details">
              {formik?.values?.multiDateEvent ? (() => {
                  const allDates = [
                    ...(formik?.values?.date ? [{ date: formik.values.date, label: formik.values.dateLabel }] : []),
                    ...(formik?.values?.additionalEventDates || []).filter(e => e?.date).map(e => ({ date: e.date, label: e.label })),
                  ];
                  const visible = allDates.slice(0, DATES_VISIBLE);
                  const remaining = allDates.slice(DATES_VISIBLE);
                  const tooltipContent = (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', padding: '4px 0' }}>
                      {remaining.map((entry, i) => (
                        <div key={i} style={{ fontSize: '11px', fontFamily: fontConfig.EventsInternalDrawerTextFont.family, whiteSpace: 'nowrap' }}>
                          {entry.label && <strong>{entry.label} </strong>}
                          {formatDate({date: entry.date, formatType:"defaultWithTimeUTC"})}
                        </div>
                      ))}
                    </div>
                  );
                  return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
                      {visible.map((entry, i) => (
                        <div key={i} className="internal-drawer__event_details-date-item">
                          {entry.label && <strong>{entry.label} </strong>}
                          <span>{formatDate({date: entry.date, formatType:"defaultWithTimeUTC"})}</span>
                        </div>
                      ))}
                      {remaining.length > 0 && (
                        <Tooltip title={tooltipContent} placement="right" arrow>
                          <span style={{ fontSize: '11px', fontFamily: fontConfig.EventsInternalDrawerTextFont.family, fontWeight: 600, color: '#3f4255', cursor: 'default', userSelect: 'none' }}>
                            + {remaining.length} more
                          </span>
                        </Tooltip>
                      )}
                    </div>
                  );
                })() : (
                  <div className="internal-drawer__event_details-date">
                    <div className="internal-drawer__event_details-date-item">
                      Date <span>{formik?.values?.date ? formatDate({date:formik?.values?.date, formatType:"defaultWithTimeUTC"}) : ''}</span>
                    </div>
                  </div>
                )}
              <div className="internal-drawer__event_details-address">
                <span className="internal-drawer__event_details-address-label">
                  {formik?.values?.eventDetails?.eventType?.toLowerCase() === "online" ? "Virtual Address" : "Location"}
                </span>
                <span className="internal-drawer__event_details-address-value">
                  {formik?.values?.eventDetails?.eventAddress?.formattedAddress}
                </span>
              </div>
              {formik?.values?.id && (
                <div className='internal-drawer__event_details-copy'>
                  <Tooltip title="Copy Link">
                    <CopyToClipboard text={checkDomain}>
                      <CopyIconGray onClick={(e) => {
                        e.stopPropagation();
                        setCopyLinkSuccess(true);
                      }} />
                    </CopyToClipboard>
                </Tooltip> 
                </div>
              )}
            </div>
          </div>
          {formik.values?.description !== '<p></p>\n' && (
            <div className="drawer_description">
              <h3>Description</h3>
              <p
                dangerouslySetInnerHTML={{ __html: formik.values?.description }}
              ></p>
            </div>
          )}
          <div className="non_member_allowing mt-4">
            <InfoIcon className="mr-3" />
            <p>
              {formik.values?.allowNonMembers ? "Non" : "Only"} members are eligible to register for this event  
            </p>
          </div>
          <div className="price_section mt-10">
            {(!formik?.values?.freeEvent && formik.values?.prices?.length > 0) &&
              formik.values?.prices?.map((price) => (
                <div className="subtotal mb-4">
                  <p>{price?.title}
                    {(price?.type?.toLowerCase() === 'optional' || price?.type?.toLowerCase() === 'addons') && <span className="price_section-optional">(Add-ons)</span>}
                  </p>
                  <h4>{calculateProductPrice(price)}</h4>
                </div>
              ))}

            {(!formik?.values?.freeEvent && formik.values?.discount?.length > 0) &&
              formik.values?.discount?.map((dis) => (
                <div className="discount mb-4">
                  <p>
                    {(dis?.discount_type === 'Date' ||  dis?.discount_type === 'date') &&
                    dis?.start_date &&
                    dis?.end_date
                      ? `${dis?.discount_name} | ${formatDate({date:dis?.start_date, formatType: "default"})}-${formatDate({date:dis?.end_date, formatType: "default"})}`
                      : dis?.discount_name}
                  </p>
                  <h4>- {dis?.price_type === 'percentage' ? `${dis?.value}%` : `${numberFormat({number:+dis?.value, decimal: 2, style: "currency"})}`}</h4>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <div className="no_date">
          <ClassNoData />
          {/* <p className="no_date_p">No Results Yet</p> */}
        </div>
      )}
    </>
  );
};

export default InternalDrawer;
